<template>
  <g>
    <path d="M75 337.5 A175 175 0 0 1 425 337.5 Z" stroke="#b1b1b1" stroke-width="1" :style="materialColor.hex != '' && formComplete ? {'fill': materialColor.hex} : {'fill': '#fff'}"/>
    <g v-if="formComplete">
      <path :d="sides.b.border.line" stroke="#ddd" stroke-width="1" fill="none"/>
      <line :x1="sides.a.border.line.xStart" :y1="sides.a.border.line.yStart" :x2="sides.a.border.line.xEnd" :y2="sides.a.border.line.yEnd" stroke="#ddd" stroke-width="1"/>
        <g v-for="(side, index) in sides" :key="index">
          <polygon :points="side.border.corner.start" :transform="side.border.corner.rotateStart" stroke="#ddd" stroke-width="1" fill="#ddd"/>
          <polygon :points="side.border.corner.end" :transform="side.border.corner.rotateEnd" stroke="#ddd" stroke-width="1" fill="#ddd"/>
          <rect :x="side.labelBackground.x" :y="side.labelBackground.y" :width="side.labelBackground.width" :height="side.labelBackground.height" style="fill:#fff" />
        </g>
    </g>
    <text v-for="side in sides" :key="side.id" dominant-baseline="middle" text-anchor="middle" fill="#002b36">
      <tspan v-if="formComplete" :x="side.labelSpace.x" :y="side.labelSpace.y" class="font-weight-bold" font-size="1em">{{side.name}}</tspan>
      <tspan v-if="formComplete" :x="side.labelSpace.x" dy="1.5em" font-size="0.7em">{{side.size}} cm</tspan>
      <tspan v-if="materialComplete" :x="side.labelSpace.x" dy="1em" font-size="0.7em">{{side.rand}}</tspan>
    </text>
    <g v-if="materialComplete">
      <g v-if="sides.b.rand === rand.saum.titleSaum.name">
        <path :d="sides.b.saum" stroke="#b1b1b1" stroke-width="1" stroke-dasharray="3,3" :style="materialColor.hex != '' && formComplete ? {'fill': materialColor.hex} : {'fill': '#fff'}"/>
        <g v-if="activeOesenArt">
          <circle v-for="(item, index) in sides.b.oesenAnzahl" :key="index" :cx="sides.b.oesenAbstand.x(index, sides.b.oesenAnzahl)" :cy="sides.b.oesenAbstand.y(index, sides.b.oesenAnzahl)" r="3" stroke="#b1b1b1" stroke-width="2" fill="#fff" />
        </g>
      </g>
      <path v-if="sides.b.rand === rand.hohlsaum.title.name" :d="sides.b.hohlsaum" stroke="#b1b1b1" stroke-width="1" :style="materialColor.hex != '' && formComplete ? {'fill': materialColor.hex} : {'fill': '#fff'}"/>
      <g v-if="sides.a.rand === rand.saum.titleSaum.name">
        <path :d="sides.a.saum" stroke-width="1" stroke="#b1b1b1" stroke-dasharray="3,3"/>
        <g v-if="activeOesenArt">
          <circle v-for="(item, index) in sides.a.oesenAnzahl" :key="index" :cx="sides.a.oesenAbstand.x(index, sides.a.oesenAnzahl)" :cy="sides.a.oesenAbstand.y(index, sides.a.oesenAnzahl)" r="3" stroke="#b1b1b1" stroke-width="2" fill="#fff" />
        </g>
      </g>
      <path v-if="sides.a.rand === rand.hohlsaum.title.name" :d="sides.a.hohlsaum" stroke-width="1" stroke="#b1b1b1"/>
    </g>
  </g>
</template>

<script>
import DataRandArt from '../../../../../data/main/config/setup/rand/randArt'

import { mapGetters } from 'vuex'

export default {
  data () {
    return {
      rand: DataRandArt.randArt
    }
  },
  computed: {
    ...mapGetters([
      'materialColor',
      'randSides',
      'formComplete',
      'materialComplete',
      'activeOesenArt',
      'calcSides'
    ]),
    sides () {
      return {
        a: {
          name: 'a',
          size: Math.round(this.calcSides[0]),
          rand: this.randSides[0].type.name,
          oesenAnzahl: this.randSides[0].oesenAnzahl,
          oesenAbstand: {
            xStart: 250 - Math.sqrt(Math.pow(160, 2) - Math.pow(15, 2)),
            xEnd: 250 + Math.sqrt(Math.pow(160, 2) - Math.pow(15, 2)),
            x: function (i, item) {
              if (item === 1) {
                return (this.xStart + this.xEnd) / 2
              } if (item === 2) {
                return this.xStart + i * (this.xEnd - this.xStart)
              } else {
                return this.xStart + (i / (item - 1)) * (this.xEnd - this.xStart)
              }
            },
            y: function (i, item) {
              return 322.5
            }
          },
          saum: 'M' + (250 - Math.sqrt(Math.pow(175, 2) - Math.pow(30, 2))) + ' 307.5 L' + (250 + Math.sqrt(Math.pow(175, 2) - Math.pow(30, 2))) + ' 307.5',
          hohlsaum: 'M' + (250 - Math.sqrt(Math.pow(175, 2) - Math.pow(9, 2))) + ' 328.5 L' + (250 + Math.sqrt(Math.pow(175, 2) - Math.pow(9, 2))) + ' 328.5',
          labelSpace: {
            x: 250,
            y: 367.5
          },
          labelBackground: {
            x: 215,
            y: 350,
            width: 70,
            height: 60
          },
          border: {
            line: {
              xStart: 75,
              yStart: 377.5,
              xEnd: 425,
              yEnd: 377.5
            },
            corner: {
              start: '75,377.5 85,372.5 85,382.5',
              rotateStart: 'rotate(0, 75, 377.5)',
              end: '425,377.5 415,372.5 415,382.5',
              rotateEnd: 'rotate(0, 425, 377.5)'
            }
          },
          id: 1
        },
        b: {
          name: 'b',
          size: Math.round(this.calcSides[1]),
          rand: this.randSides[1].type.name,
          oesenAnzahl: this.randSides[1].oesenAnzahl,
          oesenAbstand: {
            radius: 350 / 2 - 15,
            centerX: (350 / 2) + 75,
            centerY: 350 / 2 + 75 + 87.5,
            xStart: 250 - Math.cos(Math.asin(3 / 32)) * 160,
            xEnd: 250 + Math.cos(Math.asin(3 / 32)) * 160,
            x: function (i, item) {
              if (item === 1) {
                return 250
              } else {
                return Math.cos((-Math.PI + 2 * Math.asin(3 / 32)) / (item - 1) * i - Math.asin(3 / 32)) * this.radius + this.centerX
              }
            },
            y: function (i, item) {
              if (item === 1) {
                return Math.sin((270 * (Math.PI / 180))) * this.radius + this.centerY
              } else {
                return Math.sin((-Math.PI + 2 * Math.asin(3 / 32)) / (item - 1) * i - Math.asin(3 / 32)) * this.radius + this.centerY
              }
            }
          },
          saum: 'M105 337.5 A145 145 0 0 1 395 337.5',
          hohlsaum: 'M84 337.5 A166 166 0 0 1 416 337.5',
          labelSpace: {
            x: 250,
            y: 115
          },
          labelBackground: {
            x: 215,
            y: 95,
            width: 70,
            height: 60
          },
          border: {
            line: 'M35 337.5 A215 215 0 0 1 465 337.5',
            corner: {
              start: '35,337.5 30,327.5 40,327.5',
              rotateStart: 'rotate(0, 35, 337.5)',
              end: '465,337.5 460,327.5 470,327.5',
              rotateEnd: 'rotate(0, 465, 337.5)'
            }
          },
          id: 2
        }
      }
    }
  }
}
</script>

<style>
</style>
